module.exports = __webpack_public_path__ + "img/google-signin-button.d88019ea.png";